import {faCalculator} from '@fortawesome/free-solid-svg-icons';
import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class KeyPerformanceIndicator extends BaseModel {
  static faIcon = faCalculator;

  static prepareApiPayload(model) {
    return {
      id: model.id,
      name: model.name,
      formula: model.formula,
      unitOfMeasureId: model.unitOfMeasureId || null,
      sortOrder: this.hasSortOrder(model) ? model.sortOrder : null,
      hierarchyIds: model.hierarchyIds || [],
    };
  }

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.unitOfMeasure = rootStore.unitOfMeasurementStore.getById(this.unitOfMeasureId);
  }

  static hasSortOrder(model) {
    return parseInt(model.sortOrder, 10) >= 0;
  }

  searchableProperties = ['name', 'formula', 'unitOfMeasure.label'];
}

decorate(KeyPerformanceIndicator, {
  id: observable,
  name: observable,
  formula: observable,
  unitOfMeasureId: observable,
  unitOfMeasure: observable,
  hierarchyIds: observable,
  sortOrder: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
